"use strict";
module.exports = ['archivnr', 'bildthema', 'quelle', 'kuenstler', 'datierung', 'post', 'ante', 'objektart', 'sakral_profan', 'motivtypus', 'form', 'gebaeudekontext', 'staat', 'bundesland', 'standort', 'institution', 'invnr', 'ensemble', 'ensemblenr', 'registrationid'];
